function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
import { AnimationChild } from './AnimationChild';
import util from './util';
var styles = util.styles;
/**
 * @hidden
 */
// @ts-ignore

var Animation =
/** @class */
function (_super) {
  __extends(Animation, _super);

  function Animation() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */


  Animation.prototype.onEntering = function (e) {
    this.$emit('entering', e);
  };
  /**
   * @hidden
   */


  Animation.prototype.onEnter = function (e) {
    this.$emit('enter', e);
  };
  /**
   * @hidden
   */


  Animation.prototype.onEntered = function (e) {
    this.$emit('entered', e);
  };
  /**
   * @hidden
   */


  Animation.prototype.onExit = function (e) {
    this.$emit('exit', e);
  };
  /**
   * @hidden
   */


  Animation.prototype.onExiting = function (e) {
    this.$emit('exiting', e);
  };
  /**
   * @hidden
   */


  Animation.prototype.onExited = function (e) {
    this.$emit('exited', e);
  }; // @ts-ignore


  Animation.prototype.render = function (h) {
    var _a = this.$props,
        id = _a.id,
        tag = _a.tag,
        className = _a.className,
        childFactory = _a.childFactory,
        stackChildren = _a.stackChildren,
        componentChildStyle = _a.componentChildStyle,
        componentChildClassName = _a.componentChildClassName,
        other = __rest(_a, ["id", "tag", "className", "childFactory", "stackChildren", "componentChildStyle", "componentChildClassName"]);

    var parentDivClass = [styles['animation-container'], styles['animation-container-relative'], className];
    return (// @ts-ignore
      h("div", {
        attrs: {
          id: this.$props.id
        },
        "class": parentDivClass
      }, [h(AnimationChild, {
        key: 'some',
        attrs: {
          appear: this.$props.appear,
          transitionName: this.$props.transitionName,
          componentChildClassName: this.$props.componentChildClassName,
          animationEnteringStyle: this.$props.animationEnteringStyle,
          animationExitingStyle: this.$props.animationExitingStyle,
          transitionEnterDuration: this.$props.transitionEnterDuration,
          transitionExitDuration: this.$props.transitionExitDuration
        },
        on: {
          "enter": this.onEnter,
          "entering": this.onEntering,
          "entered": this.onEntered,
          "exit": this.onExit,
          "exiting": this.onExiting,
          "exited": this.onExited
        }
      }, [this.$slots.default])])
    );
  };

  Animation = __decorate([Component({
    props: {
      childFactory: Object,
      className: String,
      tag: String,
      id: String,
      animationEnteringStyle: Object,
      animationExitingStyle: Object,
      componentChildClassName: [String, Array],
      transitionName: {
        type: String,
        required: true
      },
      appear: {
        type: Boolean,
        required: true
      },
      enter: {
        type: Boolean,
        required: true
      },
      exit: {
        type: Boolean,
        required: true
      },
      transitionEnterDuration: {
        type: Number,
        required: true
      },
      transitionExitDuration: {
        type: Number,
        required: true
      }
    }
  })], Animation);
  return Animation;
}(VueComponent);

export { Animation };